import { OnboardingStepperSideMenu } from '../../_layout/OnboardingStepperSideMenu'
import { InvestorAnalysisSideProgress } from './InvestorAnalysisSideProgress'

function InvestorAnalysisSideMenu() {
  return (
    <>
      <OnboardingStepperSideMenu
        customContent={<InvestorAnalysisSideProgress />}
      />
    </>
  )
}

export { InvestorAnalysisSideMenu }
